<template>
  <div id="filter">
    <div class="row gx-2">
      <FilterTextInput :id="makeElementId('brands-input')" :modalId="makeElementId('brands-modal')" label="Značka" :selected-options="selectedBrands" @reset="selectBrands([])"/>
      <FilterTextInput :id="makeElementId('models-input')" :modalId="makeElementId('models-modal')" label="Model" :selected-options="selectedModels" @reset="selectModels([])" :is-disabled="modelInputDisabled"/>
      <FilterTextInput :id="makeElementId('bodies-input')" :modalId="makeElementId('bodies-modal')" label="Karosérie" :selected-options="selectedBodies" @reset="selectBodies([])"/>
      <FilterTextInput :id="makeElementId('fuels-input')" :modalId="makeElementId('fuels-modal')" label="Palivo" :selected-options="selectedFuels" @reset="selectFuels([])"/>
      <FilterRangeInput :id="makeElementId('price-range-input')" :modalId="makeElementId('price-range-modal')" label="Cena (Kč)" :selected-options="selectedPriceRange" @reset="selectPriceRange({})"/>
    </div>
    <div class="collapse" :id="collapseButtonId">
      <div class="row gx-2">
        <FilterRangeInput :id="makeElementId('displacement-input')" :modalId="makeElementId('displacement-modal')" label="Objem (ccm)" :selected-options="selectedDisplacement" @reset="selectDisplacement({})"/>
        <FilterRangeInput :id="makeElementId('engine-power-input')" :modalId="makeElementId('engine-power-modal')" label="Výkon (kW)" :selected-options="selectedEnginePower" @reset="selectEnginePower({})"/>
        <FilterTextInput :id="makeElementId('gearboxes-input')" :modalId="makeElementId('gearboxes-modal')" label="Převodovka / Pohon" :selected-options="[...selectedGearboxes, ...selectedWheelDrives]" @reset="selectGearboxesAndWheelDrives([[], []])"/>
        <FilterTextInput :id="makeElementId('seats-input')" :modalId="makeElementId('seats-modal')" label="Počet míst" :selected-options="selectedSeats" @reset="selectSeats([])"/>
        <FilterTextInput :id="makeElementId('car-equipments-input')" :modalId="makeElementId('car-equipments-modal')" label="Výbava" :selected-options="selectedCarEquipments" @reset="selectCarEquipments([])"/>
      </div>
      <div class="row gx-2">
        <FilterTextInput :id="makeElementId('countries-input')" :modalId="makeElementId('countries-modal')" label="Země původu" :selected-options="selectedCountries" @reset="selectCountries([])"/>
        <FilterTextInput :id="makeElementId('location-input')" :modalId="makeElementId('location-modal')" label="Lokalita" :selected-options="locationDisplayOptions" @reset="selectDistricts([])"/>
        <FilterTextInput :id="makeElementId('car-states-input')" :modalId="makeElementId('car-states-modal')" label="Stav" :selected-options="selectedCarStates" @reset="selectCarStates([])"/>
        <FilterRangeInput :id="makeElementId('mileage-input')" :modalId="makeElementId('mileage-range-modal')" label="Stav tachometru (km)" :selected-options="selectedMileage" @reset="selectMileage({})"/>
        <FilterRangeInput :id="makeElementId('rides-since-year-input')" :modalId="makeElementId('rides-since-year-modal')" label="Uvedení do provozu" :selected-options="selectedRidesSinceYear" @reset="selectRidesSinceYear({})"/>
      </div>
    </div>
    <div class="row gx-2" v-if="hasActiveFilters">
        <div class="col-12 text-end">
           <a class="btn btn-primary-light btn-sm position-relative top-50 d-inline-flex align-items-center" href="#" onclick="javascript: if(window.filter) window.filter.reset(false); return false;">
             <i class="icon icon-dismiss icon--md bg-primary"></i>&nbsp;Zrušit filtr
           </a>
        </div>
      </div>
    <button class="filter-expander box-shadow-1 collapsed" data-bs-toggle="collapse" :data-bs-target="`#${collapseButtonId}`">
      Rozšířený filtr <i class="icon icon-caret-down icon--md"></i><i class="icon icon-caret-up icon--md"></i>
    </button>

    <MultiSelectionModal :modal-id="makeElementId('brands-modal')" :options="brands" :popular-options="popularBrands" :saved-options="selectedBrands" title="Zvolte značku" :cssClasses="['modal-xsm']" @selected="selectBrands" />
    <MultiSelectionGroupModal :modal-id="makeElementId('models-modal')" :groups="models" :saved-options="selectedModels" title="Zvolte model" :cssClasses="['modal-xsm']" @selected="selectModels" />
    <MultiImageSelectionModal :modal-id="makeElementId('bodies-modal')" :options="bodies" :saved-options="selectedBodies" title="Zvolte karosérii" :cssClasses="['modal-xsm']" :columns="2" @selected="selectBodies"/>
    <MultiSelectionModal :modal-id="makeElementId('fuels-modal')" :options="fuels" :saved-options="selectedFuels" title="Zvolte palivo" :cssClasses="['modal-xsm']" @selected="selectFuels" />
    <RangeSelectionModal :modal-id="makeElementId('price-range-modal')" :options="prices" :saved-range="selectedPriceRange" :url-params="urlParams" query-name="price" title="Zvolte cenu" :cssClasses="['modal-sm']" @selected="selectPriceRange" unit="Kč" />
    <MultiSectionSelectionModal
      :modal-id="makeElementId('gearboxes-modal')"
      :sections="[
        { title: 'Převodovka', options: gearboxes, savedOptions: selectedGearboxes },
        { title: 'Pohon', options: wheelDrives, savedOptions: selectedWheelDrives }
      ]"
      :css-classes="['modal-xsm']"
      @selected="selectGearboxesAndWheelDrives"
      @section-changed="refreshGearboxSectionCounts"
    />
    <RangeSelectionModal :modal-id="makeElementId('displacement-modal')" :options="displacements" :saved-range="selectedDisplacement" :url-params="urlParams" query-name="displacement" title="Zvolte objem" :cssClasses="['modal-sm']" @selected="selectDisplacement" unit="ccm" />
    <RangeSelectionModal :modal-id="makeElementId('engine-power-modal')" :options="enginePowers" :saved-range="selectedEnginePower" :url-params="urlParams" query-name="engine_power" title="Zvolte objem" :cssClasses="['modal-sm']" @selected="selectEnginePower" unit="kW" />
    <MultiSelectionModal :modal-id="makeElementId('seats-modal')" :options="seats" :saved-options="selectedSeats" title="Zvolte počet sedadel" :cssClasses="['modal-xsm']" @selected="selectSeats" />
    <MultiSelectionModal :modal-id="makeElementId('countries-modal')" :options="countries" :saved-options="selectedCountries" title="Zvolte zemi původu" :cssClasses="['modal-xsm']" @selected="selectCountries" />
    <MultiSelectionModal :modal-id="makeElementId('car-states-modal')" :options="carStates" :saved-options="selectedCarStates" title="Zvolte stav" :cssClasses="['modal-xsm']" @selected="selectCarStates" />
    <RangeSelectionModal :modal-id="makeElementId('mileage-range-modal')" :options="mileages" :saved-range="selectedMileage" :url-params="urlParams" query-name="mileage" title="Zvolte stav tachometru" :cssClasses="['modal-sm']" @selected="selectMileage" unit="km" />
    <RangeSelectionModal :modal-id="makeElementId('rides-since-year-modal')" :options="ridesSinceYears" :reversed-options="true" :saved-range="selectedRidesSinceYear" :url-params="urlParams" :formatted="false" query-name="rides_since_year" title="Zvolte uvedené do provozu" :cssClasses="['modal-sm']" @selected="selectRidesSinceYear" unit="" />
    <LocationSelectionModal :modal-id="makeElementId('location-modal')" :saved-options="selectedDistricts" :counts="locationCounts" :css-classes="['modal-xsm']" @selected="selectDistricts" />
    <MultiSelectionModal :modal-id="makeElementId('car-equipments-modal')" :options="carEquipments" :saved-options="selectedCarEquipments" title="Zvolte výbavu" :cssClasses="['modal-xsm']" :immediateSave="true" @selected="selectCarEquipments" />
  </div>
</template>

<script>
import {camelCase, isEmpty, isNumber, isEqual, mapKeys, range, groupBy} from "lodash";
import FilterTextInput from './FilterTextInput.vue'
import FilterRangeInput from './FilterRangeInput.vue'
import RangeSelectionModal from "../modals/RangeSelectionModal.vue"
import MultiSelectionModal from "../modals/MultiSelectionModal.vue"
import ApiService from "../../services/apiService.js"
import axios from "axios";
import MultiImageSelectionModal from "../modals/MultiImageSelectionModal.vue";
import MultiSelectionGroupModal from "../modals/MultiSelectionGroupModal.vue";
import MultiSectionSelectionModal from "../modals/MultiSectionSelectionModal.vue";
import LocationSelectionModal from "../modals/LocationSelectionModal.vue";
import { LOCATIONS } from '../../data/locations.js';

const objectMapper = (array) => {
  return array.map((v, i) => {
    return { id: i, value: v.toString() }
  })
}

export default {
  name: 'Filter',

  components: {
    MultiSelectionGroupModal,
    MultiSectionSelectionModal,
    MultiImageSelectionModal,
    MultiSelectionModal,
    LocationSelectionModal,
    RangeSelectionModal,
    FilterTextInput,
    FilterRangeInput,
  },

  emits: ['search'],

  props: {
    baseUrl: {
      type: String,
      required: true
    },

    niceUrls: {
      type: Array,
      default: () => []
    },

    modelType: {
      type: String,
      default: 'personal'
    },

    advertisementType: {
      type: String,
    },

    userSlug: {
      type: String,
    },

    redirect: {
      type: Boolean,
      default: false
    },

    searchParams: {
      type: String,
      default: undefined
    },

    // The current page's already-resolved nice_url filter (server-side @nice_url.params), so the initial
    // filter state doesn't need to be re-derived by scanning niceUrls for the current pathname.
    currentFilter: {
      type: Object,
      default: null
    },

    advertisementsCount: {
      type: Number,
      default: 0
    },

    style: {
      type: String,
      default: 'default'
    }
  },

  data() {
    return {
      // Captured once at mount time – currentFilter only stays valid while the page hasn't been
      // pushState-navigated elsewhere (e.g. after picking a brand+model that resolves to a pretty URL).
      initialPathname: window.location.pathname,
      urlParams: '',
      brands: [],
      popularBrands: [],
      models: [],
      bodies: [],
      fuels: [],
      gearboxes: [],
      wheelDrives: [],
      carEquipments: [],
      displacements: [],
      enginePowers: [],
      seats: [],
      prices: [],
      carStates: [],
      mileages: [],
      ridesSinceYears: [],//objectMapper(range(1970, new Date().getFullYear() + 1, 1).reverse()),
      countries: [],
      selectedBrands: [],
      selectedModels: [],
      selectedBodies: [],
      selectedFuels: [],
      selectedPriceRange: undefined,
      selectedDisplacement: undefined,
      selectedEnginePower: undefined,
      selectedRidesSince: undefined,
      selectedRidesSinceYear: undefined,
      selectedMileage: undefined,
      selectedGearboxes: [],
      selectedWheelDrives: [],
      selectedSeats: [],
      selectedCountries: [],
      selectedCarStates: [],
      selectedCarEquipments: [],
      selectedDistricts: [],
      locationCounts: {},
      currentSort: '',
    }
  },

  computed: {
    openModalId() {
      return this.$store.state.ModalStore.openedModalId
    },
    modelInputDisabled() {
      return isEmpty(this.selectedBrands)
    },
    collapseButtonId() {
      return `collapseFilter-${this.modelType === 'personal' ? 'p' : 'u'}`
    },
    locationDisplayOptions() {
      return this.normalizeLocationSelection(this.selectedDistricts)
    },

    hasActiveFilters() {
      return !isEmpty(this.selectedBrands) ||
             !isEmpty(this.selectedModels) ||
             !isEmpty(this.selectedBodies) ||
             !isEmpty(this.selectedFuels) ||
             !isEmpty(this.selectedPriceRange) ||
             !isEmpty(this.selectedDisplacement) ||
             !isEmpty(this.selectedEnginePower) ||
             !isEmpty(this.selectedGearboxes) ||
             !isEmpty(this.selectedWheelDrives) ||
             !isEmpty(this.selectedSeats) ||
             !isEmpty(this.selectedCountries) ||
             !isEmpty(this.selectedCarStates) ||
             !isEmpty(this.selectedCarEquipments) ||
             !isEmpty(this.selectedMileage) ||
             !isEmpty(this.selectedRidesSinceYear) ||
             !isEmpty(this.selectedDistricts)
    }
  },

  watch: {
    async openModalId(value) {
      await this.loadResources(value)
    },
  },

  mounted() {
    window.addEventListener('popstate', this.handlePopState)
  },

  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState)
  },

  methods: {
    // Browser back/forward button only ever changes window.location (we only ever pushState, never
    // navigate) – without this, nothing re-renders. Two Filter instances run at once (personal/utility
    // tabs) sharing the same .js-car-list DOM, so only the currently visible tab's instance should react.
    async handlePopState() {
      const activeTab = document.getElementById(this.modelType === 'utility' ? 'nav-utility-tab' : 'nav-personal-tab')
      if(activeTab && !activeTab.classList.contains('active')) return

      this.reset(true)
      await this.loadFilterOptions()
      await this.searchAdvertisements(window.location.pathname + window.location.search, true)
    },

    reset(skipSearch) {
      this.selectBrands([], true)
      this.selectModels([], true)
      this.selectBodies([], true)
      this.selectFuels([], true)
      this.selectPriceRange({}, true)
      this.selectDisplacement([], true)
      this.selectEnginePower({}, true)
      this.selectGearboxesAndWheelDrives([[], []], true)
      this.selectSeats([], true)
      this.selectCountries([], true)
      this.selectCarStates([], true)
      this.selectMileage({}, true)
      this.selectRidesSinceYear({}, true)
      this.selectCarEquipments([], true)
      this.selectDistricts([], true)
      if (!skipSearch) this.search()
    },

    async loadResources(value) {
      const queryString = this.findQueryString()
      let params = new URLSearchParams(queryString)
      params.append('count', 'true')
      params.append('model_type', this.modelType)
      if(!isEmpty(this.advertisementType)) params.append('advertisement_type', this.advertisementType )
      if(!isEmpty(this.userSlug)) params.append('user_slug', this.userSlug.toString() )
      this.urlParams = params.toString()
      switch(value) {
        case this.makeElementId('brands-modal'):
          const brands = await this.loadResource(`brands?${params.toString()}`)
          this.brands = brands.map((i) => {
            return { id: i.id, value: i.name, label: i.name, count: i.count, popularFor: i.popularFor }
          })
          this.popularBrands = this.brands.filter(b => b.popularFor && b.popularFor.includes(this.modelType))
          break;
        case this.makeElementId('models-modal'):
          const models = await this.loadResource(`models?${params.toString()}`)
          const mappedModels = models.map((i) => {
            return { id: i.id, value: i.name, label: i.name, brandId: i.brand_id, brandName: i.brand_name, count: i.count }
          })
          this.models = groupBy(mappedModels, (model) => {
            return model.brandId
          })
          break;
        case this.makeElementId('bodies-modal'):
          const bodies = await this.loadResource(`bodies?${params.toString()}`)
          this.bodies = bodies.map((i) => {
            return { id: i.id, value: i.name, label: i.name, count: i.count, iconName: i.iconName, description: i.description }
          })
          break;
        case this.makeElementId('gearboxes-modal'):
          const [gearboxes, wheelDrives] = await Promise.all([
            this.loadResource(`gearboxes?${params.toString()}`),
            this.loadResource(`wheel_drives?${params.toString()}`)
          ])
          this.gearboxes = gearboxes.map((i) => ({ id: i.id, value: i.name, label: i.name, count: i.count }))
          this.wheelDrives = wheelDrives.map((i) => ({ id: i.id, value: i.name, label: i.name, count: i.count }))
          break;
        case this.makeElementId('fuels-modal'):
          const fuels = await this.loadResource(`fuels?${params.toString()}`)
          this.fuels = fuels.map((i) => {
            return { id: i.id, value: i.name, label: i.name, count: i.count }
          })
          break;
        case this.makeElementId('car-equipments-modal'):
          const carEquipments = await this.loadResource(`car_equipments?${params.toString()}`)
          this.carEquipments = carEquipments.map((i) => {
            return { id: i.id, value: i.name, label: i.name, count: i.count }
          })
          break;
        case this.makeElementId('price-range-modal'):
          const priceRange = await this.loadResource(`price_range?${params.toString()}`)
          this.prices = priceRange.map((v, i) => {
            return { id: i.id, value: v.toString() }
          })
          break;
        case this.makeElementId('displacement-modal'):
          const displacements = await this.loadResource(`displacements?${params.toString()}`)
          this.displacements = displacements.map((v, i) => {
            return { id: i.id, value: v.toString() }
          })
          break;
        case this.makeElementId('engine-power-modal'):
          const enginePowers = await this.loadResource(`engine_powers?${params.toString()}`)
          this.enginePowers = enginePowers.map((v, i) => {
            return { id: i.id, value: v.toString() }
          })
          break;
        case this.makeElementId('seats-modal'):
          const seats = await this.loadResource(`seats?${params.toString()}`)
          this.seats = seats.map((i) => {
            return { id: i.id, value: i.name, label: i.name, count: i.count }
          })
          break;
        case this.makeElementId('countries-modal'):
          const countries = await this.loadResource(`countries?${params.toString()}`)
          this.countries = countries.map((i) => {
            return { id: i.id, value: i.name, label: i.name, count: i.count }
          })
          break;
        case this.makeElementId('car-states-modal'):
          const carStates = await this.loadResource(`car_states?${params.toString()}`)
          this.carStates = carStates.map((i) => {
            return { id: i.id, value: i.name, label: i.name, count: i.count }
          })
          break;
        case this.makeElementId('location-modal'):
          const { data: locationData } = await ApiService.get(`location_counts?${params.toString()}`)
          this.locationCounts = locationData.counts || {}
          break;
        case this.makeElementId('mileage-range-modal'):
          const mileageRange = await this.loadResource(`mileage_range?${params.toString()}`)
          this.mileages = mileageRange.map((v, i) => {
            return { id: i.id, value: v.toString() }
          })
          break;
        case this.makeElementId('rides-since-year-modal'):
          const ridesSinceRange = await this.loadResource(`rides_since_range?${params.toString()}`)
          this.ridesSinceYears = ridesSinceRange.map((v, i) => {
            return { id: i.id, value: v.toString() }
          })
          break;
        default:
          // Clears all options in resource loaded modals.
          this.brands.splice(0, this.brands.length)
          this.models = null
          this.bodies.splice(0, this.bodies.length)
          this.gearboxes.splice(0, this.gearboxes.length)
          this.wheelDrives.splice(0, this.wheelDrives.length)
          this.fuels.splice(0, this.fuels.length)
          this.prices.splice(0, this.prices.length)
          this.displacements.splice(0, this.displacements.length)
          this.carEquipments.splice(0, this.carEquipments.length)
          this.seats.splice(0, this.seats.length)
          this.countries.splice(0, this.countries.length)
          this.carStates.splice(0, this.carStates.length)
          this.mileages.splice(0, this.mileages.length)
          this.locationCounts = {}
      }
    },

    async search(options = {}) {
      const url = this.buildUrl(options)
      if(isEmpty(url)) return
      if(this.redirect) {
        window.location.href = url
      } else {
        await this.searchAdvertisements(url)
      }
    },

    // skipPushState is true only when called from handlePopState – the URL is already correct there
    // (the browser just navigated back/forward), so pushState must NOT run again or it re-adds a
    // duplicate history entry on every back click, breaking further back/forward navigation.
    async searchAdvertisements(url, skipPushState = false) {
      const previousUrl = window.location.href
      const { data } = await axios.get(url, {
        headers: {
          // Overwrite Axios's automatically set Content-Type
          'Accept': 'application/json'
        }
      })
      if(data.advertisementsCount > 0) {
        if(!skipPushState) window.history.pushState({}, '', url)
        const advertisementCounters = document.querySelectorAll('.advertisements-count')
        for (const el of advertisementCounters) { el.textContent = data.advertisementsCount }
        if (data.title) document.title = data.title
        if (data.headline) document.querySelector('h1').innerHTML = data.headline
        const carList = document.querySelector('.js-car-list')
        const banner = carList.querySelector('.js-banner-sidebar')
        carList.innerHTML = data.html
        if (banner) carList.querySelector('.js-banner-sidebar').replaceWith(banner)
      } else {
        alert('Počet inzerátů je 0.')
        window.location.reload()
      }
    },

    buildUrl(options) {
      const params = this.buildParams(options)
      const paramsString = params.toString()
      const niceUrl = this.findNiceUrl(paramsString)
      if(niceUrl) {
        return niceUrl.url
      }

      const partial = this.findPartialNiceUrl(params)
      if(partial) {
        const covered = new Set(new URLSearchParams(partial.params_query).keys())
        const remaining = new URLSearchParams()
        for(const [key, value] of params.entries()) {
          if(!covered.has(key)) remaining.append(key, value)
        }
        const remainingString = remaining.toString()
        return remainingString.length > 0 ? `${partial.url}?${remainingString}` : partial.url
      }

      return paramsString.length > 0 ? `${this.baseUrl}?${paramsString}` : `${this.baseUrl}`
    },

    // Finds the nice_url whose own params are fully covered by the current filter selection (a subset
    // match, not exact) – e.g. brand+model still matches even when the user also picked a fuel on top.
    // Prefers the most specific match (most covered keys), matching AdvertisementsController#index, which
    // resolves @nice_url by path and merges its params with any extra query params on top.
    findPartialNiceUrl(params) {
      let best = null
      let bestKeyCount = 0
      for(const niceUrl of this.niceUrls) {
        const niceParams = new URLSearchParams(niceUrl.params_query)
        const keys = Array.from(niceParams.keys())
        if(keys.length === 0) continue
        const isSubset = keys.every(key => params.get(key) === niceParams.get(key))
        if(isSubset && keys.length > bestKeyCount) {
          best = niceUrl
          bestKeyCount = keys.length
        }
      }
      return best
    },

    buildParams(options) {
      const params = new URLSearchParams()
      this.appendSortParam(params, options)
      if(!isEmpty(this.selectedBrands)) params.append('brands', this.selectedBrands.map((o) => o.id).join(','))
      if(!isEmpty(this.selectedModels)) params.append('models', this.selectedModels.map((o) => o.id).join(','))
      if(!isEmpty(this.selectedBodies)) params.append('bodies', this.selectedBodies.map((o) => o.id).join(','))
      if(!isEmpty(this.selectedGearboxes)) params.append('gearboxes', this.selectedGearboxes.map((o) => o.id).join(','))
      if(!isEmpty(this.selectedWheelDrives)) params.append('wheel_drives', this.selectedWheelDrives.map((o) => o.id).join(','))
      if(!isEmpty(this.selectedFuels)) params.append('fuels', this.selectedFuels.map((o) => o.id).join(','))
      if(!isEmpty(this.selectedPriceRange)) params.append('price', `${this.selectedPriceRange.from}-${this.selectedPriceRange.to}` )
      if(!isEmpty(this.selectedDisplacement)) params.append('displacement', `${this.selectedDisplacement.from}-${this.selectedDisplacement.to}` )
      if(!isEmpty(this.selectedEnginePower)) params.append('engine_power', `${this.selectedEnginePower.from}-${this.selectedEnginePower.to}` )
      if(!isEmpty(this.selectedSeats)) params.append('seats_count', this.selectedSeats.map((o) => o.id).join(',') )
      if(!isEmpty(this.selectedCountries)) params.append('countries', this.selectedCountries.map((o) => o.id).join(',') )
      if(!isEmpty(this.selectedCarEquipments)) params.append('car_equipments', this.selectedCarEquipments.map((o) => o.id).join(',') )
      if(!isEmpty(this.selectedCarStates)) params.append('car_states', this.selectedCarStates.map((o) => o.id).join(',') )
      if(!isEmpty(this.selectedMileage)) params.append('mileage', `${this.selectedMileage.from}-${this.selectedMileage.to}` )
      if(!isEmpty(this.selectedRidesSinceYear)) params.append('rides_since_year', `${this.selectedRidesSinceYear.from}-${this.selectedRidesSinceYear.to}` )
      if(!isEmpty(this.advertisementType)) params.append('advertisement_type', `${this.advertisementType}` )
      if(!isEmpty(this.style) && this.style !== 'default') params.append('style', this.style )
      this.appendLocationParam(params)
      return params
    },

    findNiceUrl(params) {
      return this.niceUrls.find(u => isEqual(u.params_query, params))
    },

    findNiceUrlByPathname(pathname) {
      const urls = this.niceUrls.filter(u => u.url === pathname)
      return urls.length > 0 ? urls[0] : null
    },

    async loadResource(resource) {
      const { data } = await ApiService.get(resource)
      return data[Object.keys(data)[0]]
    },

    async loadFilterOptions() {
      const queryString = this.findQueryString()
      const params = new URLSearchParams(queryString)

      // Ensures that the sort is being saved
      if (params.has('sort')) {
        this.currentSort = params.get('sort')
      }
      if(queryString.length > 2) {
        const { data } = await ApiService.get(`filter_params${queryString}`)
        if(data.brands) this.selectBrands(data.brands, true)
        if(data.models) this.selectModels(data.models, true)
        if(data.bodies) this.selectBodies(data.bodies, true)
        if(data.gearboxes) this.selectGearboxes(data.gearboxes, true)
        if(data.wheel_drives) this.selectWheelDrives(data.wheel_drives, true)
        if(data.fuels) this.selectFuels(data.fuels, true)
        if(data.price) this.selectPriceRange(data.price, true)
        if(data.displacement) this.selectDisplacement(data.displacement, true)
        if(data.engine_power) this.selectEnginePower(data.engine_power, true)
        if(data.seats_count) this.selectSeats(data.seats_count, true)
        if(data.countries) this.selectCountries(data.countries, true)
        if(data.car_equipments) this.selectCarEquipments(data.car_equipments, true)
        if(data.car_states) this.selectCarStates(data.car_states, true)
        if(data.mileage) this.selectMileage(data.mileage, true)
        if(data.rides_since_year) this.selectRidesSinceYear(data.rides_since_year, true)
      }

      const regionSlug = params.get('region_slug')
      const regionSlugs = params.get('region_slugs')
      const districtSlug = params.get('district_slug')
      const districtSlugs = params.get('district_slugs')

      if(regionSlug) {
        const loc = LOCATIONS.find(l => l.regionSlug === regionSlug)
        if(loc) this.selectDistricts(loc.districts.map(d => ({ id: d.slug, value: d.name, label: d.name })), true)
      } else if(regionSlugs && districtSlugs) {
        const regionSlugSet = new Set(regionSlugs.split(','))
        const districtSlugSet = new Set(districtSlugs.split(','))
        const fromRegions = LOCATIONS.filter(l => regionSlugSet.has(l.regionSlug)).flatMap(loc => loc.districts.map(d => ({ id: d.slug, value: d.name, label: d.name })))
        const fromDistricts = LOCATIONS.flatMap(loc => loc.districts.filter(d => districtSlugSet.has(d.slug)).map(d => ({ id: d.slug, value: d.name, label: d.name })))
        this.selectDistricts([...fromRegions, ...fromDistricts], true)
      } else if(regionSlugs) {
        const slugSet = new Set(regionSlugs.split(','))
        const selected = LOCATIONS.filter(l => slugSet.has(l.regionSlug)).flatMap(loc => loc.districts.map(d => ({ id: d.slug, value: d.name, label: d.name })))
        this.selectDistricts(selected, true)
      } else if(districtSlug) {
        for(const loc of LOCATIONS) {
          const d = loc.districts.find(d => d.slug === districtSlug)
          if(d) { this.selectDistricts([{ id: d.slug, value: d.name, label: d.name }], true); break }
        }
      } else if(districtSlugs) {
        const slugSet = new Set(districtSlugs.split(','))
        const selected = LOCATIONS.flatMap(loc => loc.districts.filter(d => slugSet.has(d.slug)).map(d => ({ id: d.slug, value: d.name, label: d.name })))
        this.selectDistricts(selected, true)
      }
    },

    containsOnlyPageParams(queryString) {
      // Parse the query string
      const params = new URLSearchParams(queryString);
      // Collect all keys from the query string
      const keys = Array.from(params.keys());
      // Check if all keys are either "page" or "per_page" and that there are no extra keys
      return keys.every(key => key === 'page' || key === 'per_page') && keys.length <= 2;
    },

    findQueryString() {
      const queryString = window.location.search
      const onInitialPage = window.location.pathname === this.initialPathname
      // Pathname-implied base params: currentFilter while still on the page that resolved it (reliable,
      // no lookup needed), otherwise whatever nice_url matches the current pathname (e.g. after navigating
      // to a different pretty URL, or on any non-initial pathname with extra query params on top).
      const niceUrl = onInitialPage ? null : this.findNiceUrlByPathname(window.location.pathname)
      const baseParams = (onInitialPage && this.currentFilter)
        ? new URLSearchParams(this.currentFilter)
        : (niceUrl ? new URLSearchParams(niceUrl.params_query) : null)

      if(this.containsOnlyPageParams(queryString)) {
        return baseParams ? `?${baseParams.toString()}` : queryString
      }

      // Real filter params in the query string – merge them on top of the pathname-implied base params
      // (e.g. /inzerce/osobni-auta/ford/focus?bodies=2 → brands+models from the pathname, plus bodies=2).
      if(baseParams) {
        for(const [key, value] of new URLSearchParams(queryString).entries()) {
          baseParams.set(key, value)
        }
        return `?${baseParams.toString()}`
      }

      return queryString
    },

    initialize(options = {}) {
      this.reset(true)
      this.currentSort = options.sort || this.currentSort
      this.search()
    },

    selectBrands(values, skipSearch = false) {
      this.selectedBrands = values
      if(!skipSearch) {
        const brandIds = values.map(b => b.id)
        this.selectedModels = this.selectedModels.filter(m => brandIds.includes(m.brandId))
      }
      if(!skipSearch) this.search()
    },

    selectModels(values, skipSearch = false) {
      this.selectedModels = values
      if(!skipSearch) this.search()
    },

    selectBodies(values, skipSearch = false) {
      this.selectedBodies = values
      if(!skipSearch) this.search()
    },

    selectFuels(values, skipSearch = false) {
      this.selectedFuels = values
      if(!skipSearch) this.search()
    },

    selectPriceRange(value, skipSearch = false) {
      this.selectedPriceRange = value
      if(!skipSearch) this.search()
    },

    selectDisplacement(value, skipSearch = false) {
      this.selectedDisplacement = value
      if(!skipSearch) this.search()
    },

    selectEnginePower(value, skipSearch = false) {
      this.selectedEnginePower = value
      if(!skipSearch) this.search()
    },

    selectGearboxes(values, skipSearch = false) {
      this.selectedGearboxes = values
      if(!skipSearch) this.search()
    },

    selectWheelDrives(values, skipSearch = false) {
      this.selectedWheelDrives = values
      if(!skipSearch) this.search()
    },

    async refreshGearboxSectionCounts([gearboxSelected, wheelDriveSelected]) {
      const queryString = this.findQueryString()
      const params = new URLSearchParams(queryString)
      params.set('count', 'true')
      params.set('model_type', this.modelType)
      if(!isEmpty(this.advertisementType)) params.set('advertisement_type', this.advertisementType)
      if(!isEmpty(this.userSlug)) params.set('user_slug', this.userSlug.toString())
      params.delete('gearboxes')
      params.delete('wheel_drives')
      if(!isEmpty(gearboxSelected)) params.set('gearboxes', gearboxSelected.map(o => o.id).join(','))
      if(!isEmpty(wheelDriveSelected)) params.set('wheel_drives', wheelDriveSelected.map(o => o.id).join(','))
      const [gearboxes, wheelDrives] = await Promise.all([
        this.loadResource(`gearboxes?${params.toString()}`),
        this.loadResource(`wheel_drives?${params.toString()}`)
      ])
      this.gearboxes = gearboxes.map(i => ({ id: i.id, value: i.name, label: i.name, count: i.count }))
      this.wheelDrives = wheelDrives.map(i => ({ id: i.id, value: i.name, label: i.name, count: i.count }))
    },

    selectGearboxesAndWheelDrives([gearboxes, wheelDrives], skipSearch = false) {
      this.selectedGearboxes = gearboxes
      this.selectedWheelDrives = wheelDrives
      if(!skipSearch) this.search()
    },

    selectSeats(values, skipSearch = false) {
      this.selectedSeats = values
      if(!skipSearch) this.search()
    },

    selectCountries(values, skipSearch = false) {
      this.selectedCountries = values
      if(!skipSearch) this.search()
    },

    selectCarStates(values, skipSearch = false) {
      this.selectedCarStates = values
      if(!skipSearch) this.search()
    },

    selectMileage(value, skipSearch = false) {
      this.selectedMileage = value
      if(!skipSearch) this.search()
    },

    selectRidesSinceYear(value, skipSearch = false) {
      this.selectedRidesSinceYear = value
      if(!skipSearch) this.search()
    },

    async selectCarEquipments(value, skipSearch = false) {
      this.selectedCarEquipments = value
      if(!skipSearch) await this.search()
      await this.loadResources(this.makeElementId('car-equipments-modal'))
    },

    selectDistricts(values, skipSearch = false) {
      this.selectedDistricts = values
      if(!skipSearch) this.search()
    },

    // Collapses selected districts into display/param items.
    // Complete regions are replaced by a single region entry (isRegion: true).
    // Remaining individual districts are kept as-is.
    normalizeLocationSelection(districts) {
      if(isEmpty(districts)) return []
      const remaining = new Set(districts.map(d => d.id))
      const result = []
      for(const loc of LOCATIONS) {
        const allSlugs = loc.districts.map(d => d.slug)
        if(allSlugs.length > 0 && allSlugs.every(s => remaining.has(s))) {
          result.push({ id: loc.regionSlug, value: loc.region, label: loc.region, isRegion: true })
          allSlugs.forEach(s => remaining.delete(s))
        }
      }
      districts.filter(d => remaining.has(d.id)).forEach(d => result.push(d))
      return result
    },

    appendLocationParam(params) {
      if(isEmpty(this.selectedDistricts)) return
      const groups = this.normalizeLocationSelection(this.selectedDistricts)
      if(groups.length === 1) {
        params.append(groups[0].isRegion ? 'region_slug' : 'district_slug', groups[0].id)
        return
      }
      const regionGroups = groups.filter(g => g.isRegion)
      const districtGroups = groups.filter(g => !g.isRegion)
      if(districtGroups.length === 0) {
        params.append('region_slugs', regionGroups.map(g => g.id).join(','))
      } else if(regionGroups.length === 0) {
        params.append('district_slugs', districtGroups.map(g => g.id).join(','))
      } else {
        params.append('region_slugs', regionGroups.map(g => g.id).join(','))
        params.append('district_slugs', districtGroups.map(g => g.id).join(','))
      }
    },

    makeElementId(value) {
      return `${this.modelType}-${value}`
    },

    appendSortParam(params, options) {
      if(!isEmpty(options?.sort)) this.currentSort = options.sort
      if(!isEmpty(this.currentSort)) params.append('sort', this.currentSort)
    },
  },
}
</script>
